import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
    useParams,
    Link
} from "react-router-dom";
import { ToastBottomEnd } from "./Toast";
import {
    toastAddErrorMessageConfig,
    toastAddSuccessMessageConfig,
    toastEditErrorMessageConfig,
    toastEditSuccessMessageConfig, toastErrorMessageWithParameterConfig
} from "../../config/toastConfig";
import appConfig from "../../config/appConfig";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";
import InputRequire from "./InputRequire";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import { useTranslation } from "react-i18next";

const endPointConfig = {
    PRO: {
        plan: "PRO",
        store: `${appConfig.apiDomaine}/severity-levels`,
        update: id => `${appConfig.apiDomaine}/severity-levels/${id}`,
        create: `${appConfig.apiDomaine}/severity-levels/create`,
        edit: id => `${appConfig.apiDomaine}/severity-levels/${id}/edit`
    },
    MACRO: {
        plan: "MACRO",
        store: `${appConfig.apiDomaine}/severity-levels`,
        update: id => `${appConfig.apiDomaine}/severity-levels/${id}`,
        create: `${appConfig.apiDomaine}/severity-levels/create`,
        edit: id => `${appConfig.apiDomaine}/severity-levels/${id}/edit`
    },
    HUB: {
        plan: "HUB",
        store: `${appConfig.apiDomaine}/severity-levels`,
        update: id => `${appConfig.apiDomaine}/severity-levels/${id}`,
        create: `${appConfig.apiDomaine}/severity-levels/create`,
        edit: id => `${appConfig.apiDomaine}/severity-levels/${id}/edit`,
    }
};

const SeverityLevelForm = (props) => {

    //usage of useTranslation i18n
    const { t, ready } = useTranslation()

    const { id } = useParams();
    console.log('User permissions:', props.userPermissions);

    if (!id) {
        if (!verifyPermission(props.userPermissions, 'store-severity-level'))
            window.location.href = ERROR_401;
    } else {
        if (!verifyPermission(props.userPermissions, 'update-severity-level'))
            window.location.href = ERROR_401;
    }

    const endpoint = endPointConfig[props.plan];

    const defaultData = {
        name: "",
        color: "#000000",
        description: "",
    };

    const defaultError = {
        name: [],
        color: [],
        description: [],
    };
    const [data, setData] = useState(defaultData);
    const [error, setError] = useState(defaultError);
    const [startRequest, setStartRequest] = useState(false);

    useEffect(() => {
        async function fetchData() {
            if (id) {
                await axios.get(`${appConfig.apiDomaine}/severity-levels/${id}`)
                    .then(response => {
                        const newData = {
                            name: response.data.name["fr"],
                            color: response.data.color,
                            description: response.data.description["fr"],
                        };
                        setData(newData);
                    })
                    .catch(error => {
                        
                    })
                    ;
            }
        }
        if (verifyTokenExpire())
            fetchData();
    }, [appConfig.apiDomaine, id]);

    const onChangeName = (e) => {
        const newData = { ...data };
        newData.name = e.target.value;
        setData(newData);
    };

    const onChangeColor = (e) => {
        const newData = { ...data };
        newData.color = e.target.value;
        setData(newData);
    };

    const onChangeDescription = (e) => {
        const newData = { ...data };
        newData.description = e.target.value;
        setData(newData);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setStartRequest(true);
        if (verifyTokenExpire()) {
            if (id) {
                axios.put(endpoint.update(id), data)
                    .then(response => {
                        setStartRequest(false);
                        setError(defaultError);
                        ToastBottomEnd.fire(toastEditSuccessMessageConfig());
                    })
                    .catch(errorRequest => {
                        setStartRequest(false);
                        setError({ ...defaultError, ...errorRequest.response.data.error });
                        ToastBottomEnd.fire(toastEditErrorMessageConfig());
                    })
                    ;
            } else {
                axios.post(endpoint.store, data)
                    .then(response => {
                        setStartRequest(false);
                        setError(defaultError);
                        setData(defaultData);
                        ToastBottomEnd.fire(toastAddSuccessMessageConfig());
                    })
                    .catch(errorRequest => {
                        setStartRequest(false);
                        if (errorRequest.response.data.code === 422) {
                            setError({ ...defaultError, ...errorRequest.response.data.error });
                            ToastBottomEnd.fire(toastAddErrorMessageConfig());
                        } else {
                            ToastBottomEnd.fire(toastErrorMessageWithParameterConfig(errorRequest.response.data.error));
                        }

                    })
                    ;
            }
        }
    };

    const printJsx = () => {
        return (
            <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
                <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                    <div className="kt-container  kt-container--fluid ">
                        <div className="kt-subheader__main">
                            <h3 className="kt-subheader__title">
                                {t("Paramètres")}
                            </h3>
                            <span className="kt-subheader__separator kt-hidden" />
                            <div className="kt-subheader__breadcrumbs">
                                <a href="#icone" className="kt-subheader__breadcrumbs-home"><i className="flaticon2-shelter" /></a>
                                <span className="kt-subheader__breadcrumbs-separator" />
                                <Link to="/settings/severities" className="kt-subheader__breadcrumbs-link">
                                    {t("Niveau de gravité")}
                                </Link>
                                <span className="kt-subheader__breadcrumbs-separator" />
                                <a href="#button" onClick={e => e.preventDefault()} className="kt-subheader__breadcrumbs-link" style={{ cursor: "text" }}>
                                    {
                                        id ? t("Modification") : t("Ajout")
                                    }
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div className="row">
                        <div className="col">
                            <div className="kt-portlet">
                                <div className="kt-portlet__head">
                                    <div className="kt-portlet__head-label">
                                        <h3 className="kt-portlet__head-title">
                                            {
                                                id ? t("Modification d'un niveau de gravité") : t("Ajout d'un niveau de gravité")
                                            }
                                        </h3>
                                    </div>
                                </div>

                                <form method="POST" className="kt-form">
                                    <div className="kt-form kt-form--label-right">
                                        <div className="kt-portlet__body">
                                            <div className={error.name.length ? "form-group row validated" : "form-group row"}>
                                                <label className="col-xl-3 col-lg-3 col-form-label" htmlFor="name">{t("Niveau de gravité")} <InputRequire /></label>
                                                <div className="col-lg-9 col-xl-6">
                                                    <input
                                                        id="name"
                                                        type="text"
                                                        className={error.name.length ? "form-control is-invalid" : "form-control"}
                                                        placeholder={t("Veuillez entrer le nom de la gravité")}
                                                        value={data.name}
                                                        onChange={(e) => onChangeName(e)}
                                                    />
                                                    {
                                                        error.name.length ? (
                                                            error.name.map((error, index) => (
                                                                <div key={index} className="invalid-feedback">
                                                                    {error}
                                                                </div>
                                                            ))
                                                        ) : null
                                                    }
                                                </div>
                                            </div>

                                            <div className={error.color.length ? "form-group row validated" : "form-group row"}>
                                                <label className="col-xl-3 col-lg-3 col-form-label" htmlFor="color">{t("Couleur")} <InputRequire /></label>
                                                <div className="col-lg-9 col-xl-6">
                                                    <input
                                                        id="color"
                                                        type="color"
                                                        className={error.color.length ? "form-control is-invalid" : "form-control"}
                                                        placeholder={t("Veuillez choisir la couleur représentative du niveau de gravité")}
                                                        value={data.color}
                                                        onChange={(e) => onChangeColor(e)}
                                                    />
                                                    {
                                                        error.color.length ? (
                                                            error.color.map((error, index) => (
                                                                <div key={index} className="invalid-feedback">
                                                                    {error}
                                                                </div>
                                                            ))
                                                        ) : null
                                                    }
                                                </div>
                                            </div>

                                            <div className={error.description.length ? "form-group row validated" : "form-group row"}>
                                                <label className="col-xl-3 col-lg-3 col-form-label" htmlFor="description">{t("Description")}</label>
                                                <div className="col-lg-9 col-xl-6">
                                                    <textarea
                                                        id="description"
                                                        className={error.description.length ? "form-control is-invalid" : "form-control"}
                                                        placeholder={t("Veuillez entrer la description")}
                                                        cols="30"
                                                        rows="5"
                                                        value={data.description}
                                                        onChange={(e) => onChangeDescription(e)}
                                                    />
                                                    {
                                                        error.description.length ? (
                                                            error.description.map((error, index) => (
                                                                <div key={index} className="invalid-feedback">
                                                                    {error}
                                                                </div>
                                                            ))
                                                        ) : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="kt-portlet__foot">
                                            <div className="kt-form__actions text-right">
                                                {
                                                    !startRequest ? (
                                                        <button type="submit" onClick={(e) => onSubmit(e)} className="btn btn-primary">{id ? t("Modifier") : t("Enregistrer")}</button>
                                                    ) : (
                                                        <button className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light" type="button" disabled>
                                                            {t("Chargement")}...
                                                        </button>
                                                    )
                                                }
                                                {
                                                    !startRequest ? (
                                                        <Link to="/settings/severities" className="btn btn-secondary mx-2">
                                                            {t("Quitter")}
                                                        </Link>
                                                    ) : (
                                                        <Link to="/settings/severities" className="btn btn-secondary mx-2" disabled>
                                                            {t("Quitter")}
                                                        </Link>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        ready ? (
            id ? (
                verifyPermission(props.userPermissions, 'update-severity-level') ? (
                    printJsx()
                ) : null
            ) : (
                verifyPermission(props.userPermissions, 'store-severity-level') ? (
                    printJsx()
                ) : null
            )
        ) : null
    );
};

const mapStateToProps = state => {
    return {
        userPermissions: state.user.user.permissions,
        plan: state.plan.plan
    }
};

export default connect(mapStateToProps)(SeverityLevelForm);
